module.exports = __webpack_public_path__ + "images/emoji/star2.426b199dacf154ef4741.png";